module.exports = __webpack_public_path__ + "static/media/keto-starter-package.bd19eda7.png";